import React from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../../../types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles: SxStyle = {
  details: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  title: {
    fontSize: '1.1rem',
    letterSpacing: '0.5px',
    paddingLeft: '15px',
  },
  heading: {
    paddingRight: '15px',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
  },
};

function AccordionWrapper({
  children,
  name,
  expanded,
  allFieldsValid,
}: InferProps<typeof AccordionWrapper.propTypes>) {
  return (
    <>
      <Accordion expanded={expanded} elevation={2}>
        <AccordionSummary
          disabled={!expanded}
          expandIcon={<ExpandMoreIcon />}
          aria-controls={name}
          id={name}
          sx={styles.heading}
        >
          <Typography variant="h6" sx={styles.title}>
            {name}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={styles.details}>{children}</AccordionDetails>
      </Accordion>
    </>
  );
}

AccordionWrapper.propTypes = {
  children: P.any.isRequired,
  name: P.string.isRequired,
  expanded: P.bool.isRequired,
  allFieldsValid: P.bool,
};

AccordionWrapper.defaultProps = {
  allFieldsValid: false,
  expanded: false,
};

export default AccordionWrapper;
